<h3 style="text-align: center;" *ngIf="(!this.spinner) && this.nestedDataSource.data.length>=1">Related Children by COEs
</h3>
<h3 style="text-align: center;" *ngIf="(!this.spinner) && this.nestedDataSource.data.length<=0">
	<span class="warn-font-color">There are no other children related by COEs.</span>
</h3>
<mat-icon *ngIf="this.spinner">
	<mat-spinner diameter="20">
	</mat-spinner>
</mat-icon>
<div class="scroll" *ngIf="(!this.spinner) && this.nestedDataSource.data.length>=1">

	<mat-tree class="example-tree  mat-elevation-z4" [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl">
		<!--Parent Node-->
		<mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
			<div class="mat-tree-node">
				<button mat-icon-button matTreeNodeToggle>
					<mat-icon>
						{{ nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
					</mat-icon>
				</button>
				{{ node.name }}
			</div>

			<div class="nested-node" [class.example-tree-invisible]="!nestedTreeControl.isExpanded(node)">
				<ng-container matTreeNodeOutlet>

				</ng-container>
			</div>
		</mat-nested-tree-node>

		<!--Child Node-->
		<mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
			<mat-checkbox (change)="toggle($event,node)" class="checklist-leaf-node">
				{{node.msdnumber}} - {{ node.name }}
			</mat-checkbox>
		</mat-tree-node>

	</mat-tree>

	<br>
</div>